import { uploadBase64 } from 'helpers/fb-storage';

export const update = async data => {
 if (data?.avatar) data.avatar = (await uploadBase64(data.avatar))[0];
 if (data?.photo) data.photo = (await uploadBase64(data.photo))[0];

 return data;
};
